<template>
  <div class='wrapper' :key="this.$store.state.globalKey">
    <Notification v-if="this.$store.state.notification.type" />
    <Modal v-if="this.$store.state.modal.action"/>
    <Header v-if="this.$store.state.isLogged && this.$store.state.userData.user_info" />
    <transition @enter="enter" @leave="leave">
      <div v-if="this.$store.state.darkWrapper" class='dark-wrapper'></div>
    </transition>
    <CustomLoader :fullPage="true" v-if="this.$store.state.loader"/>
    <div class='page-wrapper' :class="{'webViewBottom': this.$store.statewebView}">
      <router-view :key="this.$store.state.routerKey"  class='pb-20' v-if="this.$store.state.isLogged && this.$store.state.userData.config"/>
    </div>

    <WarningContainer v-if="Object.keys(this.$store.getters.get_warnings_list).length > 0" />
    <InformatorNotification v-if="this.$store.state.informator.showNewNotification" />
    <SidePanel 
      :visible="this.$store.state.sidePanel.visible"
      :title="this.$store.state.sidePanel.title"
      @close="closeSidePanel"
    />
  </div>
</template>

<script>
import UseClientJs from '@/includes/fingerprint.js';
// import Loading from 'vue-loading-overlay';
import Modal from '@/components/service/Modal';
import CustomLoader from '@/components/service/CustomLoader';
import Login from '@/views/Login';
import Header from '@/components/service/Header';
import WarningContainer from '@/components/service/WarningContainer';
import SidePanel from '@/components/service/SidePanel';
import InformatorNotification from '@/components/service/InformatorNotification';
import 'vue-loading-overlay/dist/css/index.css';
import { gsap } from "gsap";
import Notification from './components/service/Notification.vue';

export default {
  components : {
    // Loading,
    Modal,
    Login,
    Header,
    InformatorNotification,
    WarningContainer,
    CustomLoader,
    Notification,
    SidePanel
  },
  data() {
    return {
    }
  },
  created() {
    this.setMetaColor();
    let client = new UseClientJs();
	  let fingerPrint = client.getRetailFingerptint();
    this.$store.commit('FINGERPRINT', fingerPrint);
    this.$store.commit('RESIZE', {
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight
    })
    this.getSize();
    window.addEventListener('resize', this.updateSize);
    this.isLogged();
    let ua = navigator.userAgent;
    console.log('Rebuild')
    if (ua.includes('ppWebViewApp')) {
      this.$store.commit('WEB_VIEW', 'ppWebViewApp');
      if (ua.includes('ppTopBangs/')) {
        let i = ua.split('ppTopBangs/')[1]; 
        this.$store.commit('WEB_VIEW_STATUS_BAR', i);
      }
    }
  }, 
  mounted() {
    let url = new URL(window.location.href);
    let id = url.searchParams.get("id");
    let crt_num = url.searchParams.get("crt_num");
    let control_code = url.searchParams.get("control_code");
    if (window.location.pathname == "/make_good.php" && id && crt_num && control_code) {
        this.axios.post('DoConfirm', {data: {
                'id':id,
                'crt_num':crt_num,
                'control_code':control_code
            }});
      }
  },
  methods: {
    isLogged() {
      this.$store.dispatch('isLogged', {i18n: this.$i18n});
    },
    setMetaColor() {
      let themeColor = document.querySelector("meta[name='theme-color']");
      themeColor.content = process.env.VUE_APP_THEMECOLOR;
    },
    updateSize() {
      this.$store.commit('RESIZE', {
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight
      })
      this.getSize();
    },
    getSize() {
      if (document.documentElement.clientWidth < 975) {
        this.$store.commit('IS_MOBILE', true); 
      } else {
        this.$store.commit('IS_MOBILE', false);
      }
    },
    enter(el) {
      gsap.fromTo(el, {opacity: 0}, {opacity: 0.7, duration: 0.2});
    },
    leave(el, done) {
      gsap.fromTo(el, {opacity: 0.1}, {opacity: 0, duration: 0.2, onComplete: done});
    },
    closeSidePanel() {
      this.$store.commit('SIDE_PANEL_HIDE');
    },
  },
}
</script>

<style lang="scss">
@import "@/includes/_fonts.scss";
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
  font-family: HelveticaNeue, Roboto, Nunito;
  // @media (max-width: 1500px) {
  //   font-size: 14px;
  // }
  // @media (max-width: 1350px) {
  //   font-size: 12px;
  // }
  // @media (max-width: 1120px) {
  //   font-size: 11px;
  // }
  // @media (max-width: 1000px) {
  //   font-size: 10px;
  // }
  word-wrap: break-word;
}
.grey {
  color: $color-grey;
}
.color-menu {
  color: $color-menu;
}
.color-green {
  color: $color-green;
}
.color-system-green {
  color: $color-system-green;
}
.color-acent {
  color: $color-acent;
}
.color-warning { 
  color: $color-warning;
}
.color-newsg {
  color: $color-newsg;
}
.color-yellow {
  color: $color-yellow;
}
.color-invalid {
  color: $color-invalid;
}
.border-grey {
  border-color: $primary-grey;
}
.href {
  color: $color-href !important;
}
.max-h-1 {
  max-height: 1rem !important;
}
.h100 {
  height: 100% !important;
}

.bs-tooltip-auto {
  z-index: 5000 !important;
}

.sm-no-p {
  @media (max-width: 767px) {
    padding: 0 !important;
  }
}

.wh-23 {
  @media (min-width: 992px) {
      width: 23%;
  }
}
.wh-74 {
  @media (min-width: 992px) {
      width: 73%;
  }
}
.wh-48 {
  @media (min-width: 992px) {
      width: 48%;
  }
}

a {
  text-decoration: none !important;
  color: #000;
}
b {
  font-weight: bold;
}

body:after{
    content:"";
    position:fixed; /* stretch a fixed position to the whole screen */
    top:0;
    height:100%; /* fix for mobile browser address bar appearing disappearing */
    left:0;
    right:0;
    z-index:-1; /* needed to keep in the background */
    // background:url($bg-image) center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-color: transparent;
}
.before-bg:after {
  background:url($bg-image) center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.beforew-bg {
  background-color: transparent !important;
}
.afterw-bg {
  background-color: $color-background !important;
}
.t-head-custom > tr > th {
    font-weight: normal;
    //text-transform: uppercase;
    color: $color-grey;
    font-size: 12px;
}
.table-striped > tbody.t-body-custom > tr:not(:first-child) > td {
    border-top: 1px solid $color-lightgrey;
    font-size: 16px;
}
.table-striped > thead.t-head-custom > tr {
    border-bottom: 1px solid $color-lightgrey;
}
.table-striped > tbody.t-body-custom > tr:nth-of-type(odd) > td {
    background-color: #fff;
    box-shadow: none;
}
.after-bg:after {
  background-color: $color-background !important;
  background-image: none !important;
}
.break-word {
  word-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
#app {
  color: black;
  // background-color:transparent;
  min-height: 100%;
  width: 100%;
}
.neue-bold {
  font-family: 'HelveticaNeue bold', 'Roboto bold', sans-serif !important;
}
.neue-roman {
  font-family: 'HelveticaNeue roman', 'Roboto', sans-serif !important;
}
.neue {
  font-family: 'HelveticaNeue', 'Roboto medium', sans-serif !important;
}
.light {
  font-family: "HelveticaNeue light", "Roboto light", sans-serif !important;
}
h4 {
    font-family: 'HelveticaNeue bold', 'Roboto bold', sans-serif;
}
h5, h3 {
  font-family: 'HelveticaNeue roman', 'Roboto medium', sans-serif;
}


.href, .pointer {
  cursor: pointer;
}
.c_default {
  cursor: default;
}
.btn_mb {
  text-align: center !important;
}
.btn_mb button, button.btn_mb {
  width: 90%;
  margin-top: 1rem;
}
.wrapper {
  position: relative;
  min-height: 100vh;
  background-color: $color-background;
  display: flex;
  flex-direction: column;
}
.dark-wrapper {
  bottom: 0;
  top: 0;
  width: 100%;
  background-color: #000;
  position: absolute;
  z-index: 2000;
}
.page-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  flex: 1 1 auto;
  //@media screen and (max-width: 425px) {
  //  margin-bottom: 100px;
  //}
}
.pr {
  margin-top: 42px;
}
.mw34 {
  min-width: 35px;
}
.min-w-0 {
  min-width: 0;
}
.mw40 {
  min-width: 40px;
}
.mw54 {
  min-width: 54px;
}
.simp-bg {
  background-color: $color-href;
  border: 1px solid $color-href;
}
.k-symbol {
  display: flex;
  justify-content: center;
  align-items: center; 
  span {
    font-size: 1rem;
    display: flex;
    align-items: center;
  }
}
.round-border {
  border-radius: 50%;
}
.table-div > {
  div:last-child {
    border: none !important;
  }
}
.content {
  background-color: #FFFFFF;
  box-shadow: 2px 2px 4px  rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin-bottom: 2rem;
}
    .buttons-container {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        width: 100%;
        margin-top: 1rem;
        padding-bottom: 1rem;
        button {
            margin: 0 0.5rem;
        }
    }

.footer {
    background-color: $color-menu-active;;
    font-size: 1rem;
    height: 30px;
    width: 100%;
    position: fixed;
    bottom: 0;
    &-text {
        font-size: 1.1rem;
    }
}
.require {
    color: red;
}
.webViewBottom {
  padding-bottom: 100px;
}
.string_ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.red {
    color: red;
}
.sort-option {
    border-radius: 4px;
    color: white;
    padding: 8px;
    &:hover,
    &.active {
        background: $popper-option-hover;
    }
}
.equal-width {
    flex: 1;
}
.active-filters-count {
  background: $color-menu;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 16px;
  color: white;
}

.background-empty {
  background-image: url('@/assets/empty-assets.png');
  background-position: top;
  background-repeat: no-repeat;
}

.icon-background {
  position: relative;
  background-color: $menu-bg;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  z-index: 1;
  margin-bottom: 26px;

  &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 64px;
      height: 64px;
      background-color: $menu-bg;
      border-radius: 50%;
      z-index: -1;
      opacity: 0.1;
  }
}

</style>